import { BaseModel } from './baseModel';
import { Submission } from './paper';

export class PaperGroup extends BaseModel {
  public name: string;
  public submissions: Array<Submission>;
}
